import { CartFulfillmentMethodSelectorStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import { changeCustomerFulfillmentMethodStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import { buttonBaseStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(changeCustomerFulfillmentMethodStyles, {
    ...changeCustomerFulfillmentMethodStyles,
    pickUpLocation: {
        wrapper: {
            css: css`
                margin-top: 20px;
            `,
        },
        headerText: {
            weight: 600,
        },
        changeLink: {
            css: css`
                display: none !important;
            `,
        },
        warehouseAddress: {
            wrapper: {
                css: css`
                    margin-top: 8px;
                `,
            },
            nameText: {
                as: "p",
            },
        },
    },
});
